export default "__VITE_ASSET__CBj6NHKw__"